function TitlesProps(props: any) {
  const { data } = props;
  return (
    <section className="titles-props-container container">
      {data.map((item: { id: string; name: string }, index: any) => {
        return (
          <div key={index} id={item.id} className="titles-props-content">
            <div className="titles-left-box">
              <div className="titles-detail"></div>
              <div className="titles-title">
                <h1>{item.name}</h1>
              </div>
            </div>

            <div className="titles-hr"></div>
          </div>
        );
      })}
    </section>
  );
}

export default TitlesProps;
